module.exports = __webpack_public_path__ + "static/img/2025年历-1.7049fed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/2025年历-1.png
// module id = rqXm
// module chunks = 3